import { GC_AUTH_TOKEN, GC_USER_ID } from '@/constants/jwt'
export const findToken = () => {
    if(window.sessionStorage.getItem(GC_AUTH_TOKEN) !== null) {
        return window.sessionStorage.getItem(GC_AUTH_TOKEN)
    }
    else {
        return window.localStorage.getItem(GC_AUTH_TOKEN)
    }
}